import {
  ResourceDetailsDto,
  ResourceTagDto,
  UserDto,
} from '@act/shared/data-transfer-objects';
import { EndpointDefinition } from '../utils/endpointDefinition';

export const resourceRequests = {
  patchReportedLanguage: new EndpointDefinition<
    UserDto,
    null,
    { memberId: string }
  >({
    name: 'persistLanguagePreference',
    route: '/users/:memberId',
    method: 'PATCH',
  }),

  getResourceTags: EndpointDefinition.get<ResourceTagDto[], null>({
    name: 'getResourceTags',
    route: '/resourcing/hub/tags',
  }),
  getResources: EndpointDefinition.get<
    {
      count: number;
      programs: ResourceDetailsDto[];
    },
    {
      zipcode: string;
      clientId: number;
      serviceTags?: string[];
      terms?: string;
      'page-size'?: number;
      'page-start'?: number;
    }
  >({
    name: 'getResources',
    route: '/resourcing/hub/search',
  }),
  getResource: EndpointDefinition.get<
    ResourceDetailsDto,
    { resourceId: number; zipcode: string; clientId: number }
  >({
    name: 'getResource',
    route: '/resourcing/hub/programs/:resourceId',
  }),
};
